import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';
import loadingArray from 'modules/global/reducers/loadingArraySlice';
import type { MayBe } from 'modules/global/typing/common/common';
import * as types from 'modules/publicToken/actionTypes';

/**
 * `DELETE_SUCCESS` carries the raw token id, which `loadingArraySlice` cannot pick up on its own:
 * public token ids are not uuids (hence `encodeURIComponent` in the action URLs), so its uuid
 * branch misses them. The request payloads carry the id as `publicTokenId`; `payload.id` and
 * `meta.entityId` are already handled generically.
 */
type LoadingArrayEntity = MayBe<string | { publicTokenId?: string }>;

const selectId = (entity: LoadingArrayEntity): MayBe<string> =>
  (typeof entity === 'string' ? entity : entity?.publicTokenId);

export default combineReducers({
  loading: loading(types.FETCH_PUBLIC_TOKEN),
  creating: loading(types.CREATE_PUBLIC_TOKEN),
  deleting: loadingArray(types.DELETE_PUBLIC_TOKEN, { global: { selectId } }),
  patching: loadingArray(types.UPDATE_PUBLIC_TOKEN_STATUS, { global: { selectId } }),
});
